import AccountSettingsLayout from './accountSettingsLayout';

export default AccountSettingsLayout;
